export default __webpack_public_path__ + "static/media/gaiter_2.b1999422.jpg";